import { useState } from 'react';
import { WorkbookPage, SectionTitle } from '@/components/WorkbookPage';
import { Calendar, CheckCircle2 } from 'lucide-react';

export const CheckInSheetsPage = () => {
  const [month, setMonth] = useState('');
  const [tenthBills, setTenthBills] = useState(Array(6).fill({ name: '', amount: '', paid: false }));
  const [twentyFifthBills, setTwentyFifthBills] = useState(Array(6).fill({ name: '', amount: '', paid: false }));
  
  const updateBill = (list, setList, index, field, value) => {
    const newList = [...list];
    newList[index] = { ...newList[index], [field]: value };
    setList(newList);
  };
  
  return (
    <WorkbookPage pageId="check-in-sheets" prevPage="weekly-calculator" nextPage="debt-tracker">
      <header className="mb-10">
        <div className="flex items-center gap-3 mb-4">
          <Calendar className="h-6 w-6 text-primary" />
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-foreground">
            10th/25th Check-In Sheet
          </h1>
        </div>
        <p className="text-muted-foreground">
          Monthly bill tracking using the 10th and 25th system
        </p>
      </header>
      
      <div className="mb-6">
        <label className="block text-sm font-medium mb-2">Month/Year:</label>
        <input
          type="text"
          className="border border-border rounded-lg px-4 py-2 w-full max-w-xs focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder="January 2026"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        />
      </div>
      
      {/* 10th Bills */}
      <div className="mb-8">
        <SectionTitle>Bills Due by the 10th</SectionTitle>
        <div className="bg-destructive/5 rounded-xl p-5 border border-destructive/20">
          <div className="space-y-3">
            {tenthBills.map((bill, index) => (
              <div key={index} className="flex items-center gap-3">
                <button
                  onClick={() => updateBill(tenthBills, setTenthBills, index, 'paid', !bill.paid)}
                  className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-colors shrink-0 ${
                    bill.paid ? 'bg-success border-success' : 'border-border'
                  }`}
                >
                  {bill.paid && <CheckCircle2 className="h-4 w-4 text-white" />}
                </button>
                <input
                  type="text"
                  className="flex-1 bg-transparent border-b border-dashed border-border py-2 focus:outline-none focus:border-primary"
                  placeholder="Bill name"
                  value={bill.name}
                  onChange={(e) => updateBill(tenthBills, setTenthBills, index, 'name', e.target.value)}
                />
                <input
                  type="text"
                  className="w-24 bg-transparent border-b border-dashed border-border py-2 text-right focus:outline-none focus:border-primary"
                  placeholder="$___"
                  value={bill.amount}
                  onChange={(e) => updateBill(tenthBills, setTenthBills, index, 'amount', e.target.value)}
                />
              </div>
            ))}
          </div>
          <div className="mt-4 pt-4 border-t border-destructive/20 flex justify-between">
            <span className="font-semibold">Total for 10th:</span>
            <span className="font-semibold">$____</span>
          </div>
        </div>
      </div>
      
      {/* 25th Bills */}
      <div className="mb-8">
        <SectionTitle>Bills Due by the 25th</SectionTitle>
        <div className="bg-info/5 rounded-xl p-5 border border-info/20">
          <div className="space-y-3">
            {twentyFifthBills.map((bill, index) => (
              <div key={index} className="flex items-center gap-3">
                <button
                  onClick={() => updateBill(twentyFifthBills, setTwentyFifthBills, index, 'paid', !bill.paid)}
                  className={`w-6 h-6 rounded border-2 flex items-center justify-center transition-colors shrink-0 ${
                    bill.paid ? 'bg-success border-success' : 'border-border'
                  }`}
                >
                  {bill.paid && <CheckCircle2 className="h-4 w-4 text-white" />}
                </button>
                <input
                  type="text"
                  className="flex-1 bg-transparent border-b border-dashed border-border py-2 focus:outline-none focus:border-primary"
                  placeholder="Bill name"
                  value={bill.name}
                  onChange={(e) => updateBill(twentyFifthBills, setTwentyFifthBills, index, 'name', e.target.value)}
                />
                <input
                  type="text"
                  className="w-24 bg-transparent border-b border-dashed border-border py-2 text-right focus:outline-none focus:border-primary"
                  placeholder="$___"
                  value={bill.amount}
                  onChange={(e) => updateBill(twentyFifthBills, setTwentyFifthBills, index, 'amount', e.target.value)}
                />
              </div>
            ))}
          </div>
          <div className="mt-4 pt-4 border-t border-info/20 flex justify-between">
            <span className="font-semibold">Total for 25th:</span>
            <span className="font-semibold">$____</span>
          </div>
        </div>
      </div>
      
      <div className="bg-muted/50 rounded-lg p-4">
        <p className="text-sm text-muted-foreground">
          <strong>Reminder:</strong> Print this page or copy it each month. Review and check 
          off bills as you pay them. Keep records for reference.
        </p>
      </div>
    </WorkbookPage>
  );
};
